import { useEffect, useLayoutEffect, useRef, useState } from "react";
// import AppRoute from "./routes/AppRoute";
import { selectedTheme } from "./config/themes";
// import BottomTabs from "./components/Navbar/BottomTabs";
import Layout from "./layout/Layout";
import useResponse from "./hooks/useResponse";
import { markUserGestureStart, resetUserGesture } from "./utils/userGesture";
import useDisableZoom from "./hooks/useDisableZoom";
import { useSelector } from "react-redux";
import { initGA } from "./lib/google";
import initializeCleverTap from "./lib/clevertap";
import { getToken, getAccessToken } from "./utils/storage";

export default function App() {
  useDisableZoom();

  const { isStepperDisabled } = useSelector((state) => state.user);
  const isClevertapInitialized = useRef(false);

  const { handleStep, token, location } = useResponse();

  // useEffect(() => {
  //   const newJourneyUrl = process.env.REACT_APP_NEW_JOURNEY_URL;

  //   const localToken = getToken();
  //   const accessToken = getAccessToken();

  //   const queryParams = new URLSearchParams(window.location.search);

  //   const urlToken = queryParams.get("token");
  //   const redirectionSession = queryParams.get("redirection_session");

  //   const hasAuth = !!localToken || !!accessToken || !!urlToken || !!redirectionSession;

  //   if (!hasAuth && newJourneyUrl) {
  //     setTimeout(() => {
  //       window.location.replace(newJourneyUrl);
  //     }, 1000);
  //   }
  // }, [location.pathname, token]);

  // useEffect(() => {
  //   if (token && !isStepperDisabled && location.pathname !== "/" && location.pathname !== "/home" && location.pathname !== "/enter-otp" && location.pathname !== "/confirm-details" && location.pathname !== "/select-loan" && location.pathname !== "/payment-status" && location.pathname !== "/lms-redirection" && location.pathname !== "/auto-login" && location.pathname !== "/repayment-bank-account-detail") {
  //     handleStep();
  //   }
  // }, [token]);

  useEffect(() => {
    const onCleverTapLoaded = () => {
      if (!isClevertapInitialized.current) {
        initializeCleverTap();
        isClevertapInitialized.current = true;
      }
    };

    window.addEventListener("clevertap-loaded", onCleverTapLoaded);

    return () => {
      window.removeEventListener("clevertap-loaded", onCleverTapLoaded);
    };
  }, []);

  useEffect(() => {
    const theme = selectedTheme();
    Object.keys(theme).forEach((key) => {
      document.documentElement.style.setProperty(`--${key}`, theme[key]);
    });

    initGA();
  }, []);

  useEffect(() => {
    const gestureEvents = ["click", "change", "input"];

    gestureEvents.forEach((event) => document.addEventListener(event, markUserGestureStart, true));

    return () => {
      gestureEvents.forEach((event) => document.removeEventListener(event, markUserGestureStart, true));
    };
  }, []);

  useLayoutEffect(() => {
    resetUserGesture();
  }, [location.pathname]);

  return (
    <>
      <Layout />
      {/* <AppRoute /> */}
    </>
  );
}
